// IMPORTAÇÃO DAS BIBLIOTECAS----------------------------------------------------------------------
import { useState, useEffect } from "react";
import { MdOutlineRestartAlt, MdDeleteOutline } from "react-icons/md";
import { ClipLoader } from "react-spinners"; // Icone de Carregamento spinner
import { useTranslation } from 'react-i18next';



// IMPORTAÇÃO DOS COMPONENTES----------------------------------------------------------------------
import styles from "./trash.module.css";
import { useAppContext } from "../../../AppContext.js";



const Trash = ({ deletedNotes = [], onCancel, onDelete, onRestore, clearTrash, loading, processingNoteId }) => {

  // ESTADOS E VARIÁVEIS---------------------------------------------------------------------------
  const [loadingRestore, setLoadingRestore] = useState(null);
  const { t } = useTranslation(); // Hook de tradução
  const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site



  // FUNÇÕES---------------------------------------------------------------------------------------
  // Gerencia efeitos colaterais do modal (scroll lock, fechar com ESC).
  useEffect(() => {
    document.body.style.overflow = "hidden";
    const handleEsc = (e) => {
      if (e.key === "Escape") onCancel();
    };
    window.addEventListener("keydown", handleEsc);

    // Função de limpeza
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", handleEsc);
    };
  }, [onCancel]);



  return (
    <div className={styles.overlay}>
      <main className={`${styles.modal} ${isApp ? styles.modalApp : ''}`}>

        {/* cabeçalho */}
        <header>
          <span className={styles.modalClose}>
            <label onClick={() => onCancel()}>&times;</label>
          </span>
          <h2 className={styles.title}>{t("Trash")}</h2>
          <p className={styles.subtitle}>{t("Warning! Grades will be permanently deleted after 180 days.")}</p>
        </header>

        {/* notas deletadas */}
        <section className={styles.content}>
          {deletedNotes.length === 0 ? (
            <p className={styles.empty}>A lixeira está vazia!</p>
          ) : (
            <div className={styles.list}>
              {deletedNotes.map((note, idx) => (
                <div key={note._id || idx} className={styles.noteItem}>
                  <div>
                    <p className={styles.noteInfo}>
                      {note.title.length > 20 ? `${note.title.slice(0, 20)}...` : note.title}
                    </p>
                    <span className={styles.deletedAt}>
                      {t("deleted in:")}{" "}
                      {note.date
                        ? new Date(note.date).toLocaleDateString("pt-BR", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                        })
                        : "Unknown date"}
                    </span>
                  </div>
                  <div className={styles.actions}>
                    {processingNoteId === note._id || loadingRestore === note._id ? (
                      <ClipLoader size={20} color="#888" />
                    ) : (
                      <>
                        <MdOutlineRestartAlt
                          className={styles.restoreBtn}
                          title={t("Restore note")} // Adiciona tooltip
                          onClick={async () => {
                            try {
                              setLoadingRestore(note._id);
                              await onRestore(note._id);
                              setLoadingRestore(null);
                            } catch (error) {
                              setLoadingRestore(null);
                            }
                          }}
                        />
                        <MdDeleteOutline
                          className={styles.deleteBtn}
                          title={t("Permanently delete")} // Adiciona tooltip
                          onClick={() => { onDelete(note._id) }}
                        />
                      </>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* botão limpar lixeira */}
        <button
          className={styles.button}
          onClick={() => { clearTrash() }}
          disabled={deletedNotes.length === 0 || loading}
        >
          {loading ? (
            <ClipLoader size={20} color="#fff" />
          ) : (
            t("Clear Trash")
          )}
        </button>

      </main>
    </div>
  );
};

export default Trash;